import React from 'react';
import { withFormik, Field } from 'formik';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import * as Yup from 'yup';

import ROUTES from 'config/routes';
import history from 'services/history';
import SearchModule from 'modules/search';
import Icon, { ICON_NAMES } from 'components/Icon';
import Input from 'components/Input';
import Button from 'components/Button';


const Search = props => {
  const { handleSubmit, values, handleReset, errors } = props;
  return (
    <form onSubmit={handleSubmit} className="header__search">
      <div className="search">
        <Field
          name="text"
          type="text"
          placeholder="Search"
          component={Input}
          className="search__input" />
        <button className="search__button">
          <Icon name={ICON_NAMES.search} className="icon--search" />
        </button>
      </div>
    </form>
  );
}

export default compose(
  connect(
    (state) => {
      const { text } = state.search;
      return { text };
    },
    {
      searchCommon: SearchModule.searchCommon,
    }
  ),
  withFormik({
    mapPropsToValues: (props) => {
      return {
        text: "",
      };
    },
    handleSubmit: async (values, { props }) => {
      const { text } = values;
      const { searchCommon } = props;
      history.push(`${ROUTES.searchResults}?text=${text}`);
    },
    validationSchema: (props) => {
      return Yup.object().shape({
        text: Yup.string()
          .min(3, ' ')
          .max(32, ' ')
          .required(' '),
      });
    },
  })
)(Search);
